export type OPTION_SOURCE =
    | 'COPILOT'
    | 'GENIE'
    | 'MDB'
    | 'SUBSTITUTE'
    | 'API_SEARCH'
    | 'SUGGESTED'
    | 'CUSTOM'
    | 'SA'
    | 'SUGGESTED/COMPLEMENTARY'
    | 'BORROW'
    | 'MAGIC_BOX';

export const GENIE: OPTION_SOURCE = 'GENIE';
export const COPILOT: OPTION_SOURCE = 'COPILOT';
export const MDB: OPTION_SOURCE = 'MDB';
export const SUBSTITUTE: OPTION_SOURCE = 'SUBSTITUTE';
export const API_SEARCH: OPTION_SOURCE = 'API_SEARCH';
export const SUGGESTED: OPTION_SOURCE = 'SUGGESTED';
export const SUGGESTED_COMPLEMENTARY: OPTION_SOURCE = 'SUGGESTED/COMPLEMENTARY';
export const CUSTOM: OPTION_SOURCE = 'CUSTOM';
export const SA: OPTION_SOURCE = 'SA';
export const MAGIC_BOX: OPTION_SOURCE = 'MAGIC_BOX';

export type LABEL_TYPE =
    | 'AS_EMPTY'
    | 'AS_INLINE_SEARCH'
    | 'AS_INLINE_EMPTY'
    | 'AS_SEARCH'
    | 'CHIPS'
    | 'ADD_DRUG_DIALOG'
    | 'BULK_DRUG_DIALOG'
    | 'GD_SUGGESTED'
    | 'GD_SEARCH_REPLACE'
    | 'GD_ADD_MEDICINES'
    | 'PAD_ADD_DRUG_DIALOG'
    | 'PAD_FIX_STRIP'
    | 'SNACKING_QUESTIONS'
    | 'SNACKING_QUESTIONS_NEW'
    | 'POPUP';

export const AS_EMPTY: LABEL_TYPE = 'AS_EMPTY';
export const AS_INLINE_EMPTY: LABEL_TYPE = 'AS_INLINE_EMPTY';
export const AS_SEARCH: LABEL_TYPE = 'AS_SEARCH';
export const AS_INLINE_SEARCH: LABEL_TYPE = 'AS_INLINE_SEARCH';
export const CHIPS: LABEL_TYPE = 'CHIPS';
export const ADD_DRUG_DIALOG: LABEL_TYPE = 'ADD_DRUG_DIALOG';
export const BULK_DRUG_DIALOG: LABEL_TYPE = 'BULK_DRUG_DIALOG';
export const GD_SUGGESTED: LABEL_TYPE = 'GD_SUGGESTED';
export const GD_SEARCH_REPLACE: LABEL_TYPE = 'GD_SEARCH_REPLACE';
export const GD_ADD_MEDICINES: LABEL_TYPE = 'GD_ADD_MEDICINES';
export const PAD_ADD_DRUG_DIALOG: LABEL_TYPE = 'PAD_ADD_DRUG_DIALOG';
export const PAD_FIX_STRIP: LABEL_TYPE = 'PAD_FIX_STRIP';
export const SNACKING_QUESTIONS: LABEL_TYPE = 'SNACKING_QUESTIONS';
export const SNACKING_QUESTIONS_NEW: LABEL_TYPE = 'SNACKING_QUESTIONS_NEW';
export const POPUP: LABEL_TYPE = 'POPUP';

export const AS_OPTIONS_FREQUENCTLY = 'FREQUENTLY';
export const AS_OPTIONS_SUGGESTED = 'SUGGESTED';
export const AS_OPTIONS_SEARCH = 'SEARCH';
export const AS_OPTIONS_TESTS_AND_PANELS = 'TESTS_AND_PANELS';
export const AS_OPTIONS_BOOKABLE_PACKAGES = 'BOOKABLE_PACKAGES';

export const FROM_GENIE_DASHBOARD = 'gd';
export const FROM_PRESCRIPTION_PAD = 'pad';

export type LIST_LABEL_TYPE =
    | typeof AS_OPTIONS_FREQUENCTLY
    | typeof AS_OPTIONS_SUGGESTED
    | typeof AS_OPTIONS_SEARCH
    | typeof AS_OPTIONS_TESTS_AND_PANELS
    | typeof AS_OPTIONS_BOOKABLE_PACKAGES;

export type PxElSourceTrack = {
    track?: {
        label?: LABEL_TYPE;
        index?: number;
        source?: OPTION_SOURCE | string;
        columnIndex?: number;
    };
};

export const SYMPTOMS_KIND = 'Symptoms';
export const DIAGNOSIS_KIND = 'Diagnosis';
export const MEDICINES_KIND = 'Medicines';
export const LAB_TESTS_KIND = 'Lab Tests';
export const INJECTIONS_KIND = 'Injections';
